import toast from "react-hot-toast";
import { customDateFormatType, formatNumber } from "../../utils/utils";
import { formatDateDb } from "../../utils/tools";

const { clientAPI } = require("../client");
export const deviceManagerCall = {
  approve: async (id, data) => {
    try {
      const response = await clientAPI("put", `/deviceChangeRequest/${id}/handle/`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },

  reset: async (data) => {
    try {
      const response = await clientAPI("post", `/employeeDevice/reset/`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },

  import: async (items, name) => {
    try {
      const data = {
        items,
        name
      };
      const response = await clientAPI(
        "post",
        "/employeeDevice/import-json/",
        data,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
